import getUrl from 'airship/modules/get-url'
import createRequest, {Options} from 'airship/modules/typesafe-request'
import {noopResolver} from 'airship/utils/resolvers'

import {
  AuthResponse,
  FindUserArgs,
  LoginArgs,
  RecoverAccountArgs,
  resolveAuthResponse,
} from './types'

const LOGIN_URL = 'auth:login'
const USERNAME_URL = 'auth:username'
const RECOVERY_URL = 'auth:account_recovery'

export async function login({
  username,
  password,
  staySignedIn,
  recaptchaToken,
  queryStringParams,
}: LoginArgs): Promise<AuthResponse> {
  const path = getUrl(LOGIN_URL)
  const request = createRequest({path})
  const options: Options = {
    body: {
      username,
      password,
      stay_signed_in: staySignedIn || false,
      recaptcha_token: recaptchaToken,
    },
  }
  if (queryStringParams) options.query = queryStringParams

  const response = await request.post(resolveAuthResponse, options)

  return response.body
}

export async function findUser({
  username,
  recaptchaToken,
  queryStringParams,
}: FindUserArgs): Promise<AuthResponse> {
  const path = getUrl(USERNAME_URL)
  const request = createRequest({path})
  const options: Options = {
    body: {username: username, recaptcha_token: recaptchaToken},
  }
  if (queryStringParams) options.query = queryStringParams

  const response = await request.post(resolveAuthResponse, options)

  return response.body
}

export async function recoverAccount({
  email,
  recaptchaToken,
}: RecoverAccountArgs): Promise<void> {
  const path = getUrl(RECOVERY_URL)
  const request = createRequest({path})
  const options: Options = {
    body: {email: email, recaptcha_token: recaptchaToken},
  }
  await request.post(noopResolver, options)
}
